import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UserService } from '../../_services/user.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CommonService } from "../../_services/common.service";
import { DatePipe } from '@angular/common'
import { CreateClientComponent } from '../create-client/create-client.component';
import { MatDialog } from "@angular/material";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { AnnouncementDetailComponent } from '../announcement-detail/announcement-detail.component';
import { SearchService } from '../../_services/search.service';

declare var HelpHero: any;

@Component({
  selector: 'app-master-layout',
  templateUrl: './master-layout.component.html',
  styleUrls: ['./master-layout.component.css'],
  providers: [DatePipe]
})
export class MasterLayoutComponent implements OnInit {
  isHide: boolean = false;
  public loading = false;
  public show: boolean = false;
  public buttonName: any = 'Show';
  public username: string;
  public userDetails: any = {};
  mobileQuery: MediaQueryList;
  public statisticsOptions: any = {};
  public statisticsData: any = {};
  public announcementData: any = {};
  private _mobileQueryListener: () => void;
  public invoiceID: string;
  public monthList = [
    { mKey: '0', mValue: 'Month' },
    { mKey: "1", mValue: "Jan" },
    { mKey: "2", mValue: "Feb" },
    { mKey: "3", mValue: "Mar" },
    { mKey: "4", mValue: "Apr" },
    { mKey: "5", mValue: "May" },
    { mKey: "6", mValue: "Jun" },
    { mKey: "7", mValue: "Jul" },
    { mKey: "8", mValue: "Aug" },
    { mKey: "9", mValue: "Sep" },
    { mKey: "10", mValue: "Oct" },
    { mKey: "11", mValue: "Nov" },
    { mKey: "12", mValue: "Dec" }
  ];
  public yearList: Array<any> = [];
  public selectedMonth = 0;
  public selectedYear = 0;
  public fromDate: string;
  public toDate: string
  public isDateTooltipEnable = false;
  public isShowSlide = false;
  public activeLink: string;
  public isShowResume = false;
  public clientName: string;
  public totalPrice: string;
  public profileImage: string;
  public taskCount: number;
  public receivableCount: number;
  public isShowMenu = true;
  public searchKeyword = "";
  public searchUsersList: Array<any> = [];
  public searchQuotesList: Array<any> = [];
  public searchOrdersList: Array<any> = [];
  public searchDirection = "desc";
  public searchOrderBy = "created";
  public searchLimit = 3;
  public searchPage = 1;
  public isShowSearchPanel = false;
  public isActiveBuilder = false;
  public isMobileSearch = false;
  public newClientActive = false;
  constructor(private router: Router, private titleService: Title,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private userService: UserService,
    private CommonService: CommonService,
    private datepipe: DatePipe,
    private searchService: SearchService,
    public dialog: MatDialog,
    private CommonProjectDataService: CommonProjectDataService

  ) {
    this.CommonProjectDataService.taskCount.subscribe(tcount => {
      this.taskCount = tcount
    })
    this.CommonProjectDataService.receivableCount.subscribe(recCount => {
      this.receivableCount = recCount
    })

    this.activeLink = this.router.url;
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));

    if (this.userDetails) {
      this.username = this.userDetails.first_name + ' ' + this.userDetails.last_name;
      this.profileImage = this.userDetails.profile_img;

      this.titleService.setTitle(this.userDetails.site_data.site_title);
      $("#appPrintLifeFavicon").attr("href", this.userDetails.site_data.site_favicon);

      if (this.userDetails.type === 'Shop') {
        HelpHero('identify', this.userDetails.id, {
          role: this.userDetails.type
        });
      }
    }
    if (this.userDetails.type == 'Shop' && this.userDetails.subscription_status == 'canceled') {
      this.isShowMenu = false;

    }

  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnInit() {
    if (this.userDetails && this.userDetails.type == 'Shop') {
      this.fillYears();
      this.getStatisticsData();
      this.getAnnouncementData();
    }
    this.totalPrice = localStorage.getItem('totalPrice');
    this.clientName = localStorage.getItem('userName');
    let urlArr = this.router.url.split("/");
    this.invoiceID = localStorage.getItem('resumeOrder');
    let checkquote = urlArr[1].split(";");
    if (urlArr[1] != 'invoices' && urlArr[1] != 'quotes' && checkquote[0] != 'quote' && this.invoiceID) {
      this.isShowResume = true;
    }
    else {
      this.isShowResume = false;
    }
    let el = document.createElement('script');
    el.setAttribute('src', 'assets/js/materialize.min.js');
    document.body.appendChild(el);
    // When pathName isequal to quote or invoices for builder handling
    const activeUrlPath = new URL(window.location.href).pathname;
    const pathSegments = activeUrlPath.split('/');
    const pathSegment = (pathSegments[1]) ? pathSegments[1] : '';
    this.isActiveBuilder = (pathSegment == 'quote' || pathSegment == 'invoices') && (pathSegments[2]) ? true : false;
  }

  toggle() {
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.show)
      this.buttonName = "SlideDown";
    else
      this.buttonName = "";
  }

  logout() {
    localStorage.removeItem("resumeOrder");
    localStorage.removeItem('userID');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('userExpiry');
    localStorage.removeItem('userTime');
    localStorage.removeItem('userToken');
    localStorage.removeItem("isStayLogIn");
    localStorage.removeItem("prevPrice");
    localStorage.removeItem("isorder");
    localStorage.removeItem('pfMainFilters');
    this.CommonProjectDataService.storeColorBook([]);
    this.CommonProjectDataService.storeMatrixGroup([]);
    window.location.href = '/';
  }

  getStatisticsData = function () {
    this.loading = true;
    this.getFromToDate();
    this.statisticsOptions = {
      id: localStorage.getItem("userID"),
      from_date: this.fromDate,
      to_date: this.toDate
    };
    this.CommonService.apiService(
      "POST",
      "statistics",
      this.statisticsOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.statisticsData = response.data;
        }
      },
      err => {
        this.loading = false;
      }
    );
  };

  getAnnouncementData = function () {
    this.loading = true;
    this.CommonService.apiService(
      "GET",
      "announcements/" + localStorage.getItem("userID")
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.announcementData = response.data;
        }
      },
      err => {
        this.loading = false;
      }
    );
  };

  updateNotificationStatus = function () {
    this.loading = true;
    if (this.announcementData.notificationsCount > 0) {
      this.CommonService.apiService(
        "GET",
        "notif_check/" + localStorage.getItem("userID")
      ).subscribe(
        (response: any) => {
          this.loading = false;
          this.announcementData.notificationsCount = 0;
        },
        err => {
          this.loading = false;
        }
      );
    }
  };

  dismissMessage = function (id) {
    let options = {
      id: id,
      shop_id: localStorage.getItem("userID")
    };
    this.CommonService.apiService(
      "POST",
      "announcement/dismiss",
      options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.getAnnouncementData();
        }
      },
      err => {
        this.loading = false;
      }
    );
  }

  fillYears() {
    let s: number;
    this.yearList.push({ yKey: '0', yValue: 'Year' });
    for (s = (new Date()).getFullYear(); s >= 2019; s--) {
      this.yearList.push(
        {
          yKey: s,
          yValue: s
        }
      )
    }
  }

  onMonthChange(month) {
    this.selectedMonth = month;
    this.getStatisticsData();
  }

  onYearChange(year) {
    this.selectedYear = year;
    this.getStatisticsData();
  }

  getFromToDate() {
    let dateObj = new Date();
    let month = dateObj.getMonth() + 1;
    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    let toDate, fromDate;
    let fromMonth = month;
    if (this.selectedMonth > 0 && this.selectedYear > 0) {
      day = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
      month = this.selectedMonth;
      year = this.selectedYear;
      fromMonth = month;
    }
    else if (this.selectedMonth > 0) {
      day = new Date(year, this.selectedMonth, 0).getDate();
      month = this.selectedMonth;
      fromMonth = month;
    }
    else if (this.selectedYear > 0) {
      month = this.selectedYear < year ? 12 : month;
      year = this.selectedYear;
      day = new Date(this.selectedYear, month, 0).getDate();
      fromMonth = 1;
    }
    fromDate = (fromMonth + '/01' + '/' + year);
    toDate = (month + '/' + day + '/' + year);
    this.fromDate = this.datepipe.transform(new Date(fromDate), 'MM/dd/yyyy');
    this.toDate = this.datepipe.transform(new Date(toDate), 'MM/dd/yyyy');

  }

  isEnableTooltip() {
    this.isDateTooltipEnable = this.isDateTooltipEnable == true ? false : true;
  }

  onActivate(event) {
    window.scroll(0, 0);

  }

  onActiveSlider() {
    this.isShowSlide = this.isShowSlide == false ? true : false;
  }

  openAddClientDialog(): void {
    this.newClientActive = true;
    const dialogRef = this.dialog.open(CreateClientComponent, {
      width: "900px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.newClientActive = false;
    });
  }

  newOrder() {
    this.CommonService.removeProjectTitleStorage();
    this.CommonProjectDataService.storeQuoteRequest(true);
    this.CommonProjectDataService.storeClientId(null);
    localStorage.removeItem('storeId');
    localStorage.removeItem('pfMainFilters');
    localStorage.removeItem('backgroundOrderId');
    localStorage.setItem('create_new_quote', 'true');
    this.router.navigate(["/quote/order"]);
  }

  resumeOrder() {
    if (this.invoiceID) {
      let orderType = this.CommonProjectDataService.getOrderType();
      if (orderType == 'Quote')
        this.router.navigate(["/quote/" + this.invoiceID]);
      else
        this.router.navigate(["/invoices/" + this.invoiceID]);
    }
  }

  getHelp() {
    window.open("https://theprintlife.freshdesk.com/support/home", "_blank");
  }

  viewClient() {
    let clientID = localStorage.getItem('clientId');
    if (clientID != 'null' && this.userDetails.type == 'Shop') {
      this.router.navigate(["/clients/listing/" + clientID]);
    }
  }
  openAnnouncementDialog(announcementId): void {
    let announcementData = this.announcementData.announcementList.find(x => x.announcement_id == announcementId);
    const dialogRef = this.dialog.open(AnnouncementDetailComponent, {
      width: "500px",
      data: {
        announcementData: announcementData
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dismissMessage(result);
      }
    });
  }


  toggleFunctionNew(e: MouseEvent) {
    e.stopPropagation();
    this.isHide = !this.isHide; // toggle the notification 
    this.updateNotificationStatus();
  }

  getSearchData(keyword) {
    this.searchKeyword = keyword;
    if (keyword) {
      this.isShowSearchPanel = true;
      this.getSearchList('users');
      this.getSearchList('quotes');
      this.getSearchList('orders');
    }
  }
  getAllSearchData(keyword) {
    this.isShowSearchPanel = false;
    this.searchKeyword = keyword;
    if (keyword) {
      this.searchService.setQuery(keyword);
      this.GoToSearch();
    }
  }

  GoToSearch() {
    if (this.router.url != '/search') {
      this.router.navigate(["/search"]);
    }
  }

  getSearchList = function (type) {
    this.searchOrderBy = type == 'users' ? 'created' : type == 'quotes' ? 'quote_id' : type == 'orders' ? 'invoice_id' : this.searchOrderBy;
    this.searchOptions = {
      id: localStorage.getItem("userID"),
      limit: this.searchLimit,
      page: this.searchPage,
      search: this.searchKeyword,
      orderBy: this.searchOrderBy,
      direction: this.searchDirection
    };
    this.searchOptions.type = type == 'orders' ? 'Invoice' : 'Quote';
    this.CommonService.apiService(
      "POST",
      type,
      this.searchOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.searchUsersList = type == 'users' ? response.data.records : this.searchUsersList;
            this.searchQuotesList = type == 'quotes' ? response.data.records : this.searchQuotesList;
            this.searchOrdersList = type == 'orders' ? response.data.records : this.searchOrdersList;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }
  goToClient(userId) {
    this.isShowSearchPanel = false;
    this.router.navigate(['/clients/listing', { id: userId }]);
  }

  goToQuote(id) {
    this.isShowSearchPanel = false;
    this.router.navigate(['/quote/' + id]);
  }

  goToInvoice(id) {
    this.isShowSearchPanel = false;
    this.router.navigate(['/invoices/' + id]);
  }

  setMobileSearch() {
    this.isMobileSearch = !this.isMobileSearch;
  }

  isRouteActiveForQuote() {
    let isActive = false;
    if (this.activeLink) {
      const urlArr = this.activeLink.split("/");
      if (urlArr[1]) {
        isActive = urlArr[1] === 'quote' ? true : false; 
      }
    }

    return isActive;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-master/master-layout/master-layout.component.ts